/** @jsxImportSource @emotion/react */
import { withMyTheme } from "../../../theme/theme"
import { css } from "@mui/material"
import { Typography, Box } from "@mui/material"
import { useTranslation } from "react-i18next"
import { mobileCss } from "../../../util/isMobile"
import { useQuestionnaireForm } from "../context/QuestionnaireFormContext"
import { LocationAutocomplete } from "./components/LocationAutocomplete"
import { LocationDetailsField } from "./components/LocationDetailsField"

const StepTitleStyle = withMyTheme((theme) => css`
    font-size: 2rem;
    font-weight: 600;
    color: ${theme.palette.primary.main};
    text-align: center;
    margin-bottom: 1rem;
    
    ${mobileCss(`
        font-size: 1.5rem;
    `)}
`)

const StepContentStyle = withMyTheme((theme) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2rem;
    text-align: center;
    max-width: 600px;
    margin: 0 auto;
    padding: 0 1rem;
    
    ${mobileCss(`
        max-width: 90vw;
        gap: 1.5rem;
    `)}
`)

const FormContainerStyle = withMyTheme((theme) => css`
    display: flex;
    flex-direction: column;
    gap: 2rem;
    width: 100%;
    
    ${mobileCss(`
        gap: 1.5rem;
    `)}
`)

interface CeremonyLocationStepProps {
    onStart?: () => void
}

export const CeremonyLocationStep = ({}: CeremonyLocationStepProps) => {
    const { t } = useTranslation()
    const { formData, updateCeremonyLocation } = useQuestionnaireForm()

    const handleLocationChange = (location: string) => {
        updateCeremonyLocation({ location })
    }

    const handleDetailsChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        updateCeremonyLocation({ details: event.target.value })
    }

    return (
        <div css={StepContentStyle}>
            <Typography css={StepTitleStyle}>
                {t('questionnaire.ceremonyLocation.title')}
            </Typography>
            
            <Box css={FormContainerStyle}>
                {/* Ceremony Location */}
                <LocationAutocomplete
                    label={t('questionnaire.ceremonyLocation.location')}
                    placeholder={t('questionnaire.ceremonyLocation.locationPlaceholder')}
                    value={formData.ceremonyLocation.location}
                    onChange={handleLocationChange}
                />

                {/* Ceremony Details */}
                <LocationDetailsField
                    label={t('questionnaire.ceremonyLocation.details')}
                    placeholder={t('questionnaire.ceremonyLocation.detailsPlaceholder')}
                    value={formData.ceremonyLocation.details}
                    onChange={handleDetailsChange}
                />
            </Box>
        </div>
    )
}
